/** Primary label for a batch on public surfaces (e.g. "Batch 2009"). */
export function batchPublicPrimaryName(batch: {
  al_year: number | null;
  official_title: string | null;
}): string {
  if (batch.al_year != null) return `Batch ${batch.al_year}`;
  const o = batch.official_title?.trim();
  if (o) return o;
  return "Batch";
}

function nestedCount(rows: { count: number }[] | undefined): number {
  const raw = rows?.[0]?.count;
  if (typeof raw === "number") return raw;
  if (typeof raw === "string") return parseInt(raw, 10) || 0;
  return 0;
}

/**
 * Shown on /alumni/batches when the batch has any of: project, description,
 * ExCo photo, news, logo, or custom name.
 */
export function batchShownOnPublicList(batch: {
  custom_title: string | null;
  description: string | null;
  logo_url: string | null;
  exco_photo_url: string | null;
  projects?: { count: number }[];
  news?: { count: number }[];
}): boolean {
  if (batch.custom_title?.trim()) return true;
  if (batch.description?.trim()) return true;
  if (batch.logo_url?.trim()) return true;
  if (batch.exco_photo_url?.trim()) return true;
  if (nestedCount(batch.projects) > 0) return true;
  if (nestedCount(batch.news) > 0) return true;
  return false;
}

/**
 * /alumni/batches/:slug is only available when there is a project, news, or ExCo photo.
 */
export function batchHasPublicDetailPage(batch: {
  exco_photo_url: string | null;
  projects?: { count: number }[];
  news?: { count: number }[];
}): boolean {
  if (batch.exco_photo_url?.trim()) return true;
  if (nestedCount(batch.projects) > 0) return true;
  if (nestedCount(batch.news) > 0) return true;
  return false;
}

export function projectsListedCount(batch: {
  projects?: { count: number }[];
}): number {
  return nestedCount(batch.projects);
}

export function newsListedCount(batch: { news?: { count: number }[] }): number {
  return nestedCount(batch.news);
}
